import React, { useEffect, useState, useContext } from 'react';
import { Modal, Form, Row, Col, Input, Button, Switch, message } from 'antd';
import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { ModalContext } from '../../../shared/context/ModalContext';
import { CommonCloudFirestore } from '../../services/CommonCloudFirestore';
import { DOCUMENT_SECTION, LISTENER_SECTIONS } from '../../../shared/types/firestoreType';

import Loading from '../../../shared/components/Loading/Index';

import './styles.css'

export default function ModalForm(props) {
    const modal = useContext(ModalContext);
    const sectionFirestore = new CommonCloudFirestore(DOCUMENT_SECTION);

    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        onLoad();
    }, [props.id]);

    const onLoad = async () => {
        if (!props.id)
            return;

        setLoading(true);
        const response = await sectionFirestore.getDocumentById(props.id);
        form.setFieldsValue(response);
        setLoading(false);
    };

    const onSave = async () => {
        var validations = await form.validateFields().then(values => true).catch(error => false);
        if (!validations) {
            message.warning('Por favor completa los datos del formulario.', 7);
            return;
        }

        modal.confirm("¿Esta seguro de realizar la acción?", async () => {
            setLoading(true);

            var documentData = form.getFieldsValue();
            var response = await sectionFirestore.setDocument(props.id, documentData, [LISTENER_SECTIONS])

            if (response)
                message.success(`Sección ${props.id === '' ? 'registrada' : 'modificada'} correctamente.`, 7);
            else
                message.error('Ocurrió un error inesperado.', 7);

            setLoading(false);
            onCancel();
            props.onLoad();
        });
    };

    const onCancel = (prop) => {
        if (prop === undefined || !prop?.target?.className?.toString().match("ant-modal-wrap") || prop?.type === "keydown") {
            form.resetFields();
            props.onCancel();
        }
    };

    return (
        <Modal
            title={props.id === '' ? "Nueva Sección" : "Modificar Sección"}
            open={props.open}
            destroyOnClose={true}
            onCancel={onCancel}
            footer={[
                <Button key="1" onClick={onCancel}>
                    <CloseOutlined /> Cancelar
                </Button>,
                <Button key="2" onClick={onSave} type={'primary'}>
                    <SaveOutlined /> Guardar
                </Button>
            ]}
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={{ visible: true }}
                className='mt-30'
            >
                <Loading visible={loading} label="cargando">
                    <Row>
                        <Col xs={24}>
                            <Form.Item
                                label="Título"
                                name="title"
                                className='input-material mb-15'
                                rules={[{ required: true, message: 'Campo obligatorio.' }]}
                            >
                                <Input
                                    size='large'
                                    placeholder="Ingresar título"
                                    autoComplete="off"
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24}>
                            <Form.Item
                                label="Visible"
                                name="visible"
                                valuePropName="checked"
                            >
                                <Switch defaultChecked checkedChildren="SÍ" unCheckedChildren="NO" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Loading>
            </Form>
        </Modal>
    );
}